export const PER_PAGE_OPTIONS = [
  {
    'label' : '10',
    'value' : '10'
  },
  {
    'label' : '25',
    'value' : '25'
  },
  {
    'label' : '50',
    'value' : '50'
  },
  {
    'label' : '100',
    'value' : '100'
  }
]

export const STATUS = {
  SCHEDULED : 'scheduled',
  CANCELLED : 'cancelled',
  LIVE      : 'live',
  EXPIRED   : 'expired',
  REVERTED  : 'reverted'
}

export const STATUS_OPTIONS = [
  {
    'label' : 'All',
    'value' : ''
  },
  {
    'label' : 'Scheduled',
    'value' : STATUS.SCHEDULED
  },
  {
    'label' : 'Cancelled',
    'value' : STATUS.CANCELLED
  },
  {
    'label' : 'Live',
    'value' : STATUS.LIVE
  },
  {
    'label' : 'Expired',
    'value' : STATUS.EXPIRED
  },
  {
    'label' : 'Reverted',
    'value' : STATUS.REVERTED
  }
]